module.exports = __webpack_public_path__ + "img/62.f68baa36.webp";